import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Button } from 'rsuite'
import { motion } from 'framer-motion'
import moment from 'moment'
import 'moment/locale/es'
import { useCongress } from '../../../congress/hooks'

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
  },
  active: {
    y: 0,
    opacity: 1,
    scale: 1.05
  }
}

export default function DaySelector ({ days, selected, onSelect }) {
  const { congress } = useCongress()

  return (
   <Container>
     {days?.map((day, index) => (
       <motion.div variants={itemVariants} animate={selected === index ? 'active' : undefined}>
         <Button
           block
           onClick={() => onSelect(index)}
           appearance={selected === index ? 'primary' : 'default'}
           style={{ backgroundColor: selected === index ? congress.PrimaryColor : undefined }}
         >
           <b>Día {index + 1}</b> - {day.format('LL')}
         </Button>
       </motion.div>
     ))}
   </Container>
  )
}

const Container = styled.div`
  text-align: left;
  
  button {
    margin: 1.2rem 0;
    text-align: left;
    padding: 1.5rem 2rem;
  }
`